export const UXP_CLOSE_EMBEDDED_MEDIA_VIEWER = 'close-embedded-media-viewer';
export const UXP_SYNC_PREMIERE_PLAYHEAD = 'sync-premiere-playhead';
export const UXP_ADD_PREMIERE_MARKER = 'add-premiere-marker';

export type UxpPremiereSyncAssetId = { assetId: string };

export function isEmbeddedMediaViewerPathname(pathname: string): boolean {
  return pathname === '/media-viewer' || pathname.startsWith('/media-viewer/');
}

export function mediaViewerPath(
  assetId: string,
  versionId: string,
  search: string
) {
  return { pathname: `/media-viewer/${assetId}/${versionId}`, search };
}
